import styled from 'styled-components';

export const StyledMenuBar = styled.div`
  margin-left: -4px;
  padding: 4px 0;
`;
